import {
  StatCardItem,
  TabItem,
  VehicleDetailData,
  VehicleTableRow,
} from "./types";

export const STATUS_TABS: TabItem[] = [
  { id: "finish-release", labelKey: "VECHILE_STATUS.TABS.FINISH_RELEASE" },
  { id: "ready-test", labelKey: "VECHILE_STATUS.TABS.READY_TEST" },
  { id: "waiting-tests", labelKey: "VECHILE_STATUS.TABS.WAITING_TESTS" },
  { id: "in-production", labelKey: "VECHILE_STATUS.TABS.IN_PRODUCTION" },
  { id: "in-yard", labelKey: "VECHILE_STATUS.TABS.IN_YARD" },
  { id: "waiting-entry", labelKey: "VECHILE_STATUS.TABS.WAITING_ENTRY" },
];

export const DETAIL_TABS: TabItem[] = [
  { id: "notes", labelKey: "VECHILE_STATUS.DETAIL_TABS.NOTES" },
  { id: "tests", labelKey: "VECHILE_STATUS.DETAIL_TABS.TESTS" },
  { id: "weights", labelKey: "VECHILE_STATUS.DETAIL_TABS.WEIGHTS" },
  { id: "production", labelKey: "VECHILE_STATUS.DETAIL_TABS.PRODUCTION" },
  { id: "details", labelKey: "VECHILE_STATUS.DETAIL_TABS.DETAILS" },
];

export const DETAIL_TAB_INDEX = {
  NOTES: 0,
  TESTS: 1,
  WEIGHTS: 2,
  PRODUCTION: 3,
  DETAILS: 4,
} as const;

export const MOCK_STAT_CARDS: StatCardItem[] = [
  {
    id: "monthly-average",
    value: "4.3",
    labelKey: "VECHILE_STATUS.MONTHLY_AVERAGE",
    icon: "vehicle",
  },
  {
    id: "total-vehicles",
    value: 4,
    labelKey: "VECHILE_STATUS.TOTAL_VEHICLES",
    icon: "phone",
  },
];

export const MOCK_VEHICLES: VehicleTableRow[] = [
  {
    id: 1,
    entryDate: "10/05/2026",
    customerName: "AG_TRANSPORTATION",
    vehicleType: "CLOSED_BOX",
    makeModel: "VOLVO_FH16",
    chassisNo: "376837",
    panelStatus: "NOT_INVITED",
    curtainStatus: "WITHOUT",
    inspectionStatus: "SIGNED",
    plannedFinish: "10/05/2026",
    generalStatus: "ENDING",
  },
  {
    id: 2,
    entryDate: "10/05/2026",
    customerName: "AG_TRANSPORTATION",
    vehicleType: "CLOSED_BOX",
    makeModel: "VOLVO_FH16",
    chassisNo: "376837",
    panelStatus: "NOT_INVITED",
    curtainStatus: "WITHOUT",
    inspectionStatus: "SIGNED",
    plannedFinish: "10/05/2026",
    generalStatus: "ENDING",
  },
];

export const MOCK_VEHICLE_DETAIL: VehicleDetailData = {
  titleKey: "VECHILE_STATUS.DETAIL.TITLE",
  subtitle: {
    makeModelKey: "VOLVO_FH16",
    licenseNumber: "12-345-67",
    chassisNumber: "376837",
  },
  badges: [
    {
      id: "days",
      labelKey: "VECHILE_STATUS.DETAIL.DAYS",
      variant: "danger",
    },
    {
      id: "ready-release",
      labelKey: "VECHILE_STATUS.DETAIL.SUB_STATUS",
      valueKey: "VECHILE_STATUS.DETAIL.READY_FOR_RELEASE_VALUE",
      variant: "default",
    },
    {
      id: "finished",
      labelKey: "VECHILE_STATUS.DETAIL.MAIN_STATUS",
      valueKey: "VECHILE_STATUS.DETAIL.FINISHED_VALUE",
      variant: "default",
    },
  ],
  sections: [
    {
      id: "general-details",
      titleKey: "VECHILE_STATUS.DETAIL.GENERAL_DETAILS",
      columns: 3,
      fields: [
        {
          id: "chassis",
          labelKey: "VECHILE_STATUS.DETAIL.CHASSIS",
          value: "376837",
        },
        {
          id: "license",
          labelKey: "VECHILE_STATUS.DETAIL.LICENSE_NUMBER",
          value: "12-345-67",
        },
        {
          id: "customer",
          labelKey: "VECHILE_STATUS.TABLE.CUSTOMER_NAME",
          value: "AG_TRANSPORTATION",
          valueKey: "VECHILE_STATUS.STATUS_VALUES.AG_TRANSPORTATION",
        },
        {
          id: "entry-date",
          labelKey: "VECHILE_STATUS.DETAIL.ENTRY_DATE",
          value: "10/05/2026",
        },
        {
          id: "make-model",
          labelKey: "VECHILE_STATUS.TABLE.MAKE_MODEL",
          value: "FH16",
          valueKey: "VECHILE_STATUS.STATUS_VALUES.VOLVO_FH16",
        },
        {
          id: "body-type",
          labelKey: "VECHILE_STATUS.DETAIL.BODY_TYPE",
          value: "Truck",
          valueKey: "VECHILE_STATUS.STATUS_VALUES.Truck",
        },
      ],
    },
    {
      id: "dates",
      titleKey: "VECHILE_STATUS.DETAIL.DATES",
      columns: 4,
      fields: [
        {
          id: "planned-finish",
          labelKey: "VECHILE_STATUS.DETAIL.PLANNED_FINISH",
          value: "10/05/2026",
        },
        {
          id: "release-date",
          labelKey: "VECHILE_STATUS.DETAIL.RELEASE_DATE",
          value: "15/05/2026",
        },
        {
          id: "gap",
          labelKey: "VECHILE_STATUS.DETAIL.GAP",
          value: "5",
          valueKey: "VECHILE_STATUS.DETAIL.GAP_VALUE",
          variant: "success",
        },
      ],
    },
  ],
  production: {
    status: {
      mainStatusValueKey: "VECHILE_STATUS.DETAIL.FINISHED_VALUE",
      mainStatusHelperKey: "VECHILE_STATUS.PRODUCTION.MAIN_STATUS_HELPER",
      subStatusValue: "ready-for-release",
      subStatusOptions: [
        {
          value: "ready-for-release",
          valueKey: "VECHILE_STATUS.DETAIL.READY_FOR_RELEASE_VALUE",
        },
        {
          value: "in-production",
          valueKey: "VECHILE_STATUS.TABS.IN_PRODUCTION",
        },
      ],
    },
    items: [
      {
        id: "curtain",
        titleKey: "VECHILE_STATUS.PRODUCTION.CURTAIN",
        value: "curtain",
        options: [
          {
            value: "curtain",
            valueKey: "VECHILE_STATUS.PRODUCTION.CURTAIN_VALUE",
          },
          {
            value: "without",
            valueKey: "VECHILE_STATUS.STATUS_VALUES.WITHOUT",
          },
        ],
      },
      {
        id: "hydraulic-tailgate",
        titleKey: "VECHILE_STATUS.PRODUCTION.HYDRAULIC_TAILGATE",
        value: "not-ordered",
        options: [
          {
            value: "not-ordered",
            valueKey: "VECHILE_STATUS.STATUS_VALUES.NOT_INVITED",
          },
          {
            value: "ordered",
            valueKey: "VECHILE_STATUS.PRODUCTION.ORDERED",
          },
        ],
      },
    ],
  },
  weights: {
    fields: [
      {
        id: "chassis-entry",
        labelKey: "VECHILE_STATUS.WEIGHTS.CHASSIS_ENTRY",
        value: "1",
      },
      {
        id: "final-general",
        labelKey: "VECHILE_STATUS.WEIGHTS.FINAL_GENERAL",
        value: "1",
      },
      {
        id: "front-weight",
        labelKey: "VECHILE_STATUS.WEIGHTS.FRONT_WEIGHT",
        value: "1",
      },
      {
        id: "rear-weight",
        labelKey: "VECHILE_STATUS.WEIGHTS.REAR_WEIGHT",
        value: "1",
      },
    ],
    netWeightValueKey: "VECHILE_STATUS.WEIGHTS.NET_WEIGHT_VALUE",
  },
  tests: {
    signatures: [
      {
        id: "air",
        labelKey: "VECHILE_STATUS.TESTS.AIR",
        status: "unsigned",
      },
      {
        id: "electricity",
        labelKey: "VECHILE_STATUS.TESTS.ELECTRICITY",
        status: "signed",
      },
      {
        id: "general",
        labelKey: "VECHILE_STATUS.TESTS.GENERAL",
        status: "unsigned",
      },
    ],
    markingSheet: {
      value: "full",
      options: [
        {
          value: "full",
          valueKey: "VECHILE_STATUS.TESTS.MARKING_SHEET_FULL",
        },
        {
          value: "empty",
          valueKey: "VECHILE_STATUS.TESTS.MARKING_SHEET_EMPTY",
        },
      ],
    },
    inspectionDate: "10/05/2026",
  },
  notes: {
    draft: "",
    history: [
      {
        id: "note-1",
        roleKey: "VECHILE_STATUS.NOTES.ROLE_MANAGER",
        timestamp: "10/10/2024 09:30",
        contentKey: "VECHILE_STATUS.NOTES.HISTORY_ITEM_1",
      },
      {
        id: "note-2",
        roleKey: "VECHILE_STATUS.NOTES.ROLE_MANAGER",
        timestamp: "10/10/2024 09:30",
        contentKey: "VECHILE_STATUS.NOTES.HISTORY_ITEM_1",
      },
    ],
  },
};

export const getMockVehicleDetail = (
  vehicle: VehicleTableRow
): VehicleDetailData => ({
  ...MOCK_VEHICLE_DETAIL,
  subtitle: {
    makeModelKey: vehicle.makeModel,
    licenseNumber: "12-345-67",
    chassisNumber: vehicle.chassisNo,
  },
  sections: MOCK_VEHICLE_DETAIL.sections.map((section) => ({
    ...section,
    fields: section.fields.map((field) => {
      if (field.id === "customer") {
        return { ...field, value: vehicle.customerName };
      }
      if (field.id === "chassis") {
        return { ...field, value: vehicle.chassisNo };
      }
      if (field.id === "make-model") {
        return { ...field, value: vehicle.makeModel };
      }
      if (field.id === "entry-date") {
        return { ...field, value: vehicle.entryDate };
      }
      if (field.id === "planned-finish") {
        return { ...field, value: vehicle.plannedFinish };
      }
      return field;
    }),
  })),
  production: {
    ...MOCK_VEHICLE_DETAIL.production,
    items: MOCK_VEHICLE_DETAIL.production.items.map((item) => ({ ...item })),
  },
  weights: {
    ...MOCK_VEHICLE_DETAIL.weights,
    fields: MOCK_VEHICLE_DETAIL.weights.fields.map((field) => ({ ...field })),
  },
  tests: {
    ...MOCK_VEHICLE_DETAIL.tests,
    signatures: MOCK_VEHICLE_DETAIL.tests.signatures.map((signature) => ({
      ...signature,
    })),
    markingSheet: {
      ...MOCK_VEHICLE_DETAIL.tests.markingSheet,
      options: MOCK_VEHICLE_DETAIL.tests.markingSheet.options.map(
        (option) => ({ ...option })
      ),
    },
  },
  notes: {
    draft: "",
    history: MOCK_VEHICLE_DETAIL.notes.history.map((item) => ({ ...item })),
  },
});
